export default __webpack_public_path__ + "static/media/aboutusTop.89ae060a.webp";